import {getCookie} from '@@/js/utils/cookies';
import {debounce} from '@@/js/utils/debounce';

class PostsBlock extends HTMLElement {
  constructor() {
    super();

    this.abortController = new AbortController();
    this.isLoading = false;
    this.url = window.location.href.split('?')[0];
    this.terms = this.querySelectorAll('[data-term]');
    this.views = this.querySelectorAll('[data-view]');
    this.items = this.querySelector('[data-items]');
    this.loadMore = this.querySelector('[data-load-more]');
    this.searchInput = this.querySelector('[type="search"]');
    this.view = getCookie('postsView') || 'grid';
    this.term = 'all';
    this.search = '';
    this.page = 1;
  }

  connectedCallback() {

    this.terms && this.terms.forEach(term => {
      term.addEventListener('click', e => {
        this.page = 1;
        this.term = term.dataset.term;
        this.terms.forEach(term => term.classList.toggle('is-active',
          term.dataset.term === this.term));

        this.loadPosts();
      });
    });

    this.views && this.views.forEach(view => {
      view.addEventListener('click', e => {
        this.view = view.dataset.view;
        this.views.forEach(view => view.classList.toggle('is-active',
          view.dataset.view === this.view));
        document.cookie = `postsView=${this.view}; path=/;`;

        this.items.classList.toggle('is-grid', this.view === 'grid');
        this.items.classList.toggle('is-list', this.view === 'list');
      });
    });

    const onInput = debounce(() => {
      if (this.isLoading) {
        this.abortController.abort();
        this.abortController = new AbortController();
        this.isLoading = false;
      }

      this.search = this.searchInput.value;
      this.loadPosts();
    }, 1000);

    this.searchInput &&
    this.searchInput.addEventListener('input', onInput.bind(this));

    this.loadMore && this.loadMore.addEventListener('click', e => {
      this.page++;
      this.loadPosts(true);
    });
  }

  loadPosts(append = false) {
    this.classList.add('is-loading');
    this.isLoading = true;
    fetch(
      `${this.url}?term=${this.term}&pag=${this.page}&search=${this.search}`, {
        signal: this.abortController.signal,
      }).then(response => response.text()).then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const posts = doc.querySelector('[data-items]');
      const more = doc.querySelector('[data-load-more]');

      if (append) {
        this.items.insertAdjacentHTML('beforeend', posts.innerHTML);
      } else {
        this.items.innerHTML = posts.innerHTML;
      }

      if (this.loadMore) {
        this.loadMore.style.display = !more ? 'none' : 'grid';
      }

      this.classList.remove('is-loading');
      this.isLoading = false;
    });
  }

  disconnectedCallback() {
  }
}

customElements.define('posts-block', PostsBlock);
